var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationObserver',{ref:"observer"},[(_vm.model)?_c('NetworkInfos',{attrs:{"networkInfos":_vm.model.networkInfos},on:{"sendData":_vm.updateData}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }